<template>
  <div
    class="h-screen w-full flex items-center justify-center bg-transparent p-5"
  >
    <div
      class="sm:w-sm rounded-lg w-full bg-white p-5 flex flex-col space-y-5 text-center items-center"
    >
      <div class="flex items-center justify-center">
        <button
          class="transition-all duration-300 cursor-pointer size-8 min-w- rounded-lg flex items-center justify-center bg-gray-100 hover:bg-gray-300"
          type="button"
          @click="$emit('close')"
        >
          <Icon name="ph:x" size="20" />
        </button>
      </div>
      <p class="sm:text-base text-sm">{{ $t("new.please_login") }}</p>
      <div class="flex items-center space-x-5 w-full">
        <BaseButton
          class="w-full"
          :label="$t('auth.register.register')"
          variant="secondary"
          @click="navigateNoAction('/auth/register')"
        />
        <BaseButton
          class="w-full"
          :label="$t('auth.login.login')"
          @click="navigateNoAction('/auth/login')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(["close"]);

const localePath = useLocalePath();
const newArt = useNewArtworkStore();

const navigateNoAction = async (route: string) => {
  await navigateTo(localePath(route));
  newArt.closeNewArtwork();
};
</script>
